"use strict";
/* Generated by ts-generator ver. 0.0.8 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebtAuctionHouse = void 0;
var geb_contract_base_1 = require("@reflexer-finance/geb-contract-base");
var DebtAuctionHouse = /** @class */ (function (_super) {
    __extends(DebtAuctionHouse, _super);
    function DebtAuctionHouse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DebtAuctionHouse.prototype.AUCTION_HOUSE_TYPE = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "AUCTION_HOUSE_TYPE", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    DebtAuctionHouse.prototype.accountingEngine = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "accountingEngine", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    DebtAuctionHouse.prototype.activeDebtAuctions = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "activeDebtAuctions", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    DebtAuctionHouse.prototype.addAuthorization = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "addAuthorization", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    DebtAuctionHouse.prototype.amountSoldIncrease = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "amountSoldIncrease", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    DebtAuctionHouse.prototype.auctionsStarted = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "auctionsStarted", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    DebtAuctionHouse.prototype.authorizedAccounts = function (address, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "authorizedAccounts", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [address], multicall);
    };
    DebtAuctionHouse.prototype.bidDecrease = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "bidDecrease", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    DebtAuctionHouse.prototype.bidDuration = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "bidDuration", "outputs": [{ "internalType": "uint48", "name": "", "type": "uint48" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    DebtAuctionHouse.prototype.bids = function (uinteger, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "bids", "outputs": [{ "internalType": "uint256", "name": "bidAmount", "type": "uint256" }, { "internalType": "uint256", "name": "amountToSell", "type": "uint256" }, { "internalType": "address", "name": "highBidder", "type": "address" }, { "internalType": "uint48", "name": "bidExpiry", "type": "uint48" }, { "internalType": "uint48", "name": "auctionDeadline", "type": "uint48" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [uinteger], multicall);
    };
    DebtAuctionHouse.prototype.contractEnabled = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "contractEnabled", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    DebtAuctionHouse.prototype.decreaseSoldAmount = function (id, amountToBuy, bid) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "uint256", "name": "amountToBuy", "type": "uint256" }, { "internalType": "uint256", "name": "bid", "type": "uint256" }], "name": "decreaseSoldAmount", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [id, amountToBuy, bid]);
    };
    DebtAuctionHouse.prototype.disableContract = function () {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "disableContract", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, []);
    };
    DebtAuctionHouse.prototype.modifyParameters__Bytes32Address = function (parameter, addr) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "parameter", "type": "bytes32" }, { "internalType": "address", "name": "addr", "type": "address" }], "name": "modifyParameters", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [parameter, addr]);
    };
    DebtAuctionHouse.prototype.modifyParameters__Bytes32Uint256 = function (parameter, data) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "parameter", "type": "bytes32" }, { "internalType": "uint256", "name": "data", "type": "uint256" }], "name": "modifyParameters", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [parameter, data]);
    };
    DebtAuctionHouse.prototype.protocolToken = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "protocolToken", "outputs": [{ "internalType": "contract TokenLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    DebtAuctionHouse.prototype.removeAuthorization = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "removeAuthorization", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    DebtAuctionHouse.prototype.restartAuction = function (id) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "restartAuction", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [id]);
    };
    DebtAuctionHouse.prototype.safeEngine = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "safeEngine", "outputs": [{ "internalType": "contract SAFEEngineLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    DebtAuctionHouse.prototype.settleAuction = function (id) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "settleAuction", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [id]);
    };
    DebtAuctionHouse.prototype.startAuction = function (incomeReceiver, amountToSell, initialBid) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "incomeReceiver", "type": "address" }, { "internalType": "uint256", "name": "amountToSell", "type": "uint256" }, { "internalType": "uint256", "name": "initialBid", "type": "uint256" }], "name": "startAuction", "outputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [
            incomeReceiver,
            amountToSell,
            initialBid,
        ]);
    };
    DebtAuctionHouse.prototype.terminateAuctionPrematurely = function (id) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "name": "terminateAuctionPrematurely", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [id]);
    };
    DebtAuctionHouse.prototype.totalAuctionLength = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "totalAuctionLength", "outputs": [{ "internalType": "uint48", "name": "", "type": "uint48" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    return DebtAuctionHouse;
}(geb_contract_base_1.BaseContractAPI));
exports.DebtAuctionHouse = DebtAuctionHouse;
